import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { GetMyCohorts } from "../services/cohortService";
import { updateCohortTimezone } from "./cohortHelpers";

export const useMyJoinedCohorts = (username) => {
  const key = "myJoinedCohorts";

  const query = useQuery({
    queryKey: [key, username],
    queryFn: async () => {
      const data = await GetMyCohorts();
      return updateCohortTimezone(data.data.data.reverse());
    },
  });

  return query;
};
